import React from 'react';
import { PlusIcon, FlagIcon } from 'lucide-react';
import { BudgetLineItem as BudgetLineItemType, Condition } from '../types/budget';
interface BudgetLineItemProps {
  item: BudgetLineItemType;
  condition?: Condition;
  onAddCondition: () => void;
  onEditCondition: () => void;
}
export function BudgetLineItem({
  item,
  condition,
  onAddCondition,
  onEditCondition
}: BudgetLineItemProps) {
  const isZeroBudget = item.budgetAmount === 0;
  const formatCurrency = (value: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);
  const formatPercent = (value: number) => new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1
  }).format(value / 100);
  return <div className={`flex items-center py-4 px-6 border-b border-gray-100 hover:bg-gray-50/50 transition-colors relative ${isZeroBudget ? 'opacity-50' : ''}`} data-id="element-1">
      {/* Condition indicator border */}
      {condition && <div className="absolute left-0 top-0 bottom-0 w-1 bg-accent-1" data-id="element-2" />}

      <div className="flex-1 flex items-center gap-4" data-id="element-3">
        <span className={`text-base font-body ${condition ? 'font-medium text-primary' : 'font-normal text-gray-800'}`} data-id="element-4">
          {item.name}
        </span>

        {condition ? <button onClick={onEditCondition} className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-1/20 text-yellow-800 text-xs border border-accent-1/30 hover:bg-accent-1/30 transition-colors font-medium shadow-sm" title="View Condition" data-id="element-5">
            <FlagIcon className="w-3.5 h-3.5" data-id="element-6" />
            <span data-id="element-7">Condition Added</span>
          </button> : <button onClick={onAddCondition} className="flex items-center gap-1.5 px-2.5 py-1 rounded-md text-accent bg-accent/5 hover:bg-accent/10 border border-transparent hover:border-accent/20 transition-colors text-xs font-medium" data-id="element-8">
            <PlusIcon className="w-3.5 h-3.5" data-id="element-9" />
            <span data-id="element-10">Add Condition</span>
          </button>}
      </div>

      <div className="w-24 text-right text-sm font-body font-normal text-gray-500" data-id="element-11">
        {formatPercent(item.percentOfBudget)}
      </div>

      <div className="w-32 text-right text-sm font-body font-normal text-gray-500" data-id="element-12">
        {item.costPerSqFt > 0 ? formatCurrency(item.costPerSqFt) : '-'}
      </div>

      <div className="w-36 text-right text-base font-body font-medium text-primary" data-id="element-13">
        {item.budgetAmount > 0 ? formatCurrency(item.budgetAmount) : '-'}
      </div>
    </div>;
}